import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import { ReactComponent as KubitBrandmark } from '../../../assets/images/kubit-brandmark.svg';

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  color: #fff;
`;
const Heading = styled.h1`
  margin: 0;
  font: inherit;
  font-size: 26px;
  font-weight: 400;
  line-height: 32px;
`;
const HighlightedPart = styled.b`
  font-weight: 600;
`;

const GetStartedHeading = () => (
  <Container>
    <KubitBrandmark width={32} height={32} fill={theme.colors.white} />
    <Heading>
      <HighlightedPart>Get started</HighlightedPart> with Kubit
    </Heading>
  </Container>
);

export default GetStartedHeading;
